
import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const NotificationBarServiceApi = createApi({
    reducerPath: 'NotificationBarServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        AddAnnouncement: builder.mutation({
            query: (details) => ({
                url: `/PagesManagement/AddAnnouncement`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetAnnouncementById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/PagesManagement/GetAnnouncementById?id=${parseInt(id)}`),
                method: 'GET',
            }),

            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useAddAnnouncementMutation,
    useLazyGetAnnouncementByIdQuery,
} = NotificationBarServiceApi;

export default NotificationBarServiceApi;